// A due date expires at the end of its local calendar day.
export function isPastDueDate(value, now = new Date()) {
  if (!value) return false;
  const date = value instanceof Date ? new Date(value) : new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return false;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  return date < today;
}

export function isOverdueItem(item = {}) {
  const closed = ['pagato', 'incassato', 'completato', 'completata', 'annullato', 'annullata', 'cancellato', 'cancellata', 'archiviato', 'archiviata', 'stornato', 'rifiutato', 'rifiutata', 'chiuso', 'chiusa', 'completed', 'done', 'rejected', 'cancelled', 'canceled', 'paid', 'void'];
  return !closed.includes(String(item.status || '').trim().toLowerCase()) && isPastDueDate(item.dueDate);
}
